import { render, staticRenderFns } from "./report5.vue?vue&type=template&id=65c6decc&scoped=true"
import script from "./report5.vue?vue&type=script&lang=js"
export * from "./report5.vue?vue&type=script&lang=js"
import style0 from "./report5.vue?vue&type=style&index=0&id=65c6decc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c6decc",
  null
  
)

export default component.exports